export const GET_BEANS_SUCCESS = "GET_BEANS_SUCCESS";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_SINGLE_DATA_SUCCESS = "GET_SINGLE_DATA_SUCCESS";
export const GET_FACTS_SUCCESS = "GET_FACTS_SUCCESS";

export const GET_DATA_FAILURE = "GET_FACTS_FAILURE";
